@import "~@uipath/apollo-core/src/scss/base-host.scss";

.chip {
  display: inline-block;
  outline: none;
  background: none;
  min-width: auto;
  min-height: 16px;
  border: solid $border-thick-s;
  white-space: nowrap;
  box-sizing: border-box;

  &.normal {
    border-radius: $border-radius-l;
    height: 16px;
    padding: 0px $border-radius-l;
    font-weight: $font-weight-semibold;
    line-height: 14px;
    font-size: $font-xs-size;
  }

  &.large {
    display: inline-flex !important;
    box-sizing: border-box;
    align-items: center;
    vertical-align: middle;
    justify-content: center;
    border-radius: 16px;
    height: 32px;
    padding: 8px 12px;
    font-weight: $font-weight-default;
    line-height: 20px;
    font-size: $font-m-size;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  //Default will be grey
  color: var(--color-foreground);
  background-color: var(--color-background-gray);
  border-color: var(--color-foreground);

  // Red
  &.error,
  &.critical,
  &.failed,
  &.faulted {
    color: var(--color-error-text);
    background-color: var(--color-error-background);
    border-color: var(--color-error-text);
  }
  // Gray
  &.loading,
  &.stopping,
  &.stopped,
  &.terminating,
  &.suspended,
  &.abandoned,
  &.deleted {
    color: var(--color-foreground);
    background-color: var(--color-background-gray);
    border-color: var(--color-background-gray);
  }

  //Card
  &.card {
    color: var(--color-foreground);
    background-color: var(--color-background-disabled);
    border-color: var(--color-background-disabled);
  }
  
  // Yellow
  &.pending,
  &.resumed,
  &.new,
  &.retried,
  &.high,
  &.warning {
    color: var(--color-warning-text);
    background-color: var(--color-warning-background);
    border-color: var(--color-warning-icon);
  }
  // Blue
  &.running,
  &.inprogress,
  &.medium,
  &.info,
  &.resolved {
    color: var(--color-info-foreground);
    background-color: var(--color-info-background);
    border-color: var(--color-info-foreground);
  }
  // Green
  &.completed,
  &.successful,
  &.low,
  &.success {
    color: var(--color-success-text);
    background-color: var(--color-success-background);
    border-color: var(--color-success-icon);
  }

  &.hideBorder {
    border: none;
  }

  .close-btn {
    text-align: center;
    vertical-align: middle;
    margin-left: 4px;
    cursor: pointer;
  }

  .chip-icon {
    margin-right: 4px;
  }
}
